import React from "react";
import { useNavigate, Link } from "react-router-dom";
import { MailCheck, ArrowRight, ArrowLeft } from "lucide-react";
import { motion } from "framer-motion";

const ForgotPassSent = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#F9FAFB] flex flex-col justify-center py-12 px-4 sm:px-6 lg:px-8 relative selection:bg-blue-100 selection:text-blue-900">
      
      {/* Background glow */}
      <div className="absolute top-1/4 left-1/3 w-96 h-96 bg-blue-100/40 rounded-full blur-3xl pointer-events-none -z-10" />

      <div className="max-w-md mx-auto w-full">
        
        {/* Top Header / Back Nav */}
        <div className="flex items-center justify-between mb-8">
          <Link
            to="/login"
            className="inline-flex items-center gap-2 text-xs font-semibold text-slate-500 hover:text-[#007AFF] transition-colors"
          >
            <ArrowLeft className="w-4 h-4" /> Back to Sign In
          </Link>

          <Link to="/" className="flex items-center gap-2">
            <img
              src="/logo.png"
              alt="Americar Logo"
              className="h-9 w-auto object-contain"
            />
          </Link>
        </div>

        {/* Card */}
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4 }}
          className="bg-white rounded-3xl p-8 sm:p-10 shadow-[0_12px_45px_rgba(0,122,255,0.06),0_1px_3px_rgba(0,0,0,0.04)] border border-slate-100 text-center"
        >
          <div className="w-16 h-16 rounded-2xl bg-emerald-50 border border-emerald-100 flex items-center justify-center text-emerald-600 mx-auto mb-6 shadow-xs">
            <MailCheck className="w-8 h-8" />
          </div>

          <h1 className="text-2xl font-extrabold text-slate-900 tracking-tight mb-2">
            Check Your Email
          </h1>
          
          <p className="text-sm text-slate-500 font-medium leading-relaxed mb-8">
            We've sent a secure password reset link to your business email. Please check your inbox and spam folder to create your new password.
          </p>

          <button
            onClick={() => navigate("/login")}
            className="w-full py-3.5 px-4 bg-[#007AFF] hover:bg-blue-600 text-white rounded-xl font-bold text-sm shadow-md shadow-blue-500/20 hover:shadow-blue-500/35 transition-all duration-200 flex items-center justify-center gap-2"
          >
            <span>Return to Sign In</span>
            <ArrowRight className="w-4 h-4" />
          </button>

          <div className="mt-8 pt-6 border-t border-slate-100 text-center">
            <p className="text-xs text-slate-400">
              Didn't receive the email?{" "}
              <Link to="/forgot-password" className="text-[#007AFF] font-bold hover:underline">
                Resend link
              </Link>
            </p>
          </div>
        </motion.div>

      </div>

    </div>
  );
};

export default ForgotPassSent;